import React, { useEffect, useRef, useState } from 'react';
import { readReviewRecovery, writeReviewRecovery } from '../utils/reviewDraftRecovery';

export function useGoalDraftRecovery<T>(key: string, value: T, dirty: boolean, restore: (value: T) => void) {
  const scope = useRef('');
  const [recovered, setRecovered] = useState<T | null>(null);
  const [stored, setStored] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  useEffect(() => {
    if (scope.current !== key) {
      scope.current = key;
      setRecovered(readReviewRecovery<T>(key)); setStored(false); setUnavailable(false);
      return;
    }
    if (key && dirty && !recovered) {
      const ok = writeReviewRecovery(key, value);
      setStored(ok); setUnavailable(!ok);
    }
  }, [key, value, dirty, recovered]);
  const clear = () => { writeReviewRecovery(key, null); setRecovered(null); setStored(false); };
  const banner = recovered ? <div role="status" className="rounded-lg border border-purple-300 bg-purple-50 p-3 text-sm text-slate-900">
    <p>An unsubmitted goal draft was found in this tab. Review it before saving.</p>
    <button type="button" className="mt-2 mr-4 underline" onClick={() => { restore(recovered); setRecovered(null); }}>Restore my draft</button>
    <button type="button" className="underline" onClick={clear}>Discard recovered draft</button>
  </div> : dirty && key ? <p role="status" className="text-sm text-muted">{stored ? 'Draft saved in this tab for up to 12 hours. It has not been submitted. Signing out clears it.' : unavailable ? 'This browser could not keep a recovery copy. Keep this tab open until you submit.' : 'Keeping a recovery copy of your draft…'}</p> : null;
  return { clear, banner };
}
